import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Config } from 'src/infrastructure/config';
import { LocalstorageService } from 'src/services/core/localstorage/localstorage.service';
import { UserService } from 'src/services/core/user/user.service';
import { UserInfoService } from 'src/services/request/user/userinfo.service';
import { LoggedUserService } from 'src/services/state/loggeduser/loggeduser.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'ShareMeMobileView';

  private routerEventsSubscription?: Subscription;
  private scrollToTopInterval?: number;

  constructor(
    private userInfoService: UserInfoService,
    private userStateService: LoggedUserService,
    private userService: UserService,
    private router: Router,
    private localStorage: LocalstorageService
  ) { }

  ngOnInit(): void {
    this.localStorage.removeLocalStorageItem(Config.lastSearchTextKey);
    this.localStorage.removeLocalStorageItem(Config.lsGroupTabKey);
    this.localStorage.removeLocalStorageItem(Config.lastSearchTextKeyGroups);

    this.routerEventsSubscription = this.router.events.subscribe((val) => {
      if (!(val instanceof NavigationStart)) {
        return;
      }

      if (val.url.indexOf('appRecovery=1') !== -1) {
        return;
      }

      if (window.location.pathname !== val.url) {
        this.localStorage.setLocalStorageItem(Config.goToRouteLSKey, val.url);
      }
    });

    if (this.userService.isUserLogged()) {
      this.userInfoService.loadUser().subscribe(user => {
        this.userStateService.addNewUser(user);
      })
    }
    else {
      // this.router.navigate(['/registration'])
    }
  }

  ngOnDestroy(): void {
    this.routerEventsSubscription?.unsubscribe();

    if (this.scrollToTopInterval) {
      window.clearInterval(this.scrollToTopInterval);
    }
  }

  onActivate(_event: any): void {
    if (this.scrollToTopInterval) {
      window.clearInterval(this.scrollToTopInterval);
    }

    this.scrollToTopInterval = window.setInterval(() => {
      const pos = window.pageYOffset;

      if (pos > 0) {
        window.scrollTo(0, pos - 20);
      } else {
        window.clearInterval(this.scrollToTopInterval);
        this.scrollToTopInterval = undefined;
      }
    }, 16);
  }
}
